// extracted by mini-css-extract-plugin
module.exports = {"plan_detail_remark":"Overview_plan_detail_remark__37_JE"};